import { Grid, Spacer } from '@zillow/constellation';
import { getIsReadOnly, getIsWithdrawn } from '../../utils/business-logic';
import { ApplicationOverviewAccordion } from './Accordion/ApplicationOverviewAccordion';
import { ApplicationOverviewListing } from './Listing';
import { ApplicationStatusHistory } from './StatusHistory';
import { ApplicationOverviewWhatsNext } from './WhatsNext';
import { ListingAlert } from './ListingAlert';
import { AlreadyInvitedAlert } from './AlreadyInvitedAlert';
import { useApplicationContext } from '../../contexts/ApplicationContext';

export function ApplicationOverview() {
  const { application } = useApplicationContext();
  const isReadOnly = getIsReadOnly(application);
  const isWithdrawn = getIsWithdrawn(application);

  return (
    <Spacer marginTop="sm">
      <ApplicationOverviewWhatsNext application={application} />
      {!isReadOnly && <ListingAlert application={application} />}
      <Spacer marginTop="xs" marginBottom="sm">
        <AlreadyInvitedAlert application={application} />
      </Spacer>
      {isReadOnly && <ApplicationOverviewListing application={application} />}
      <Grid display="grid" gridTemplateColumns="repeat(12, 1fr)" paddingBottom="sm" gap="md">
        {!isWithdrawn && (
          <Grid gridColumnEnd={{ default: 'span 12', xl_gte: isReadOnly ? 'span 9' : 'span 12' }}>
            <ApplicationOverviewAccordion isReadOnly={isReadOnly} />
          </Grid>
        )}

        {isReadOnly && (
          <Grid gridColumnEnd={{ default: `span 12`, xl_gte: !isWithdrawn ? `span 3` : `span 12` }}>
            <ApplicationStatusHistory application={application} />
          </Grid>
        )}
      </Grid>
    </Spacer>
  );
}
